<template>
    <Spinner v-if="isSubmitting" />
    <Toast />

    <input ref="fileInput" type="file" style="display: none" accept="application/pdf" @change="onFileSelected" />
    <div class="card fluid companydatacard">
        <div class="field grid">
            <label for="name" class="col-4" :class="{'p-error': v$.CompanyName.$invalid && submitted}">{{ translated('companyname') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="100" v-model="CompanyName" :class="{'p-invalid':v$.CompanyName.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>
        <div class="field grid">
            <label for="street" class="col-4" :class="{'p-error': v$.Street.$invalid && submitted}">{{ translated('street') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="50" v-model="Street" :class="{'p-invalid':v$.Street.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>
        <div class="field grid">
            <label for="street1" class="col-4"></label>
            <div class="col-8">
                <InputText type="text" maxlength="50" v-model="Street1" :disabled="!editenabled" />
            </div>                        
        </div>
        <div class="field grid">
            <label class="col-4" :class="{'p-error': v$.HouseNumber.$invalid && submitted}">{{ translated('housenumber') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="10" v-model="HouseNumber" :class="{'p-invalid':v$.HouseNumber.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>		
        <div class="field grid">
            <label class="col-4" :class="{'p-error': (v$.Zip.$invalid || v$.City.$invalid) && submitted}">{{ translated('zipcity') }} *</label>
            <div class="col-2">
                <InputText type="text" maxlength="6" v-model="Zip" :class="{'p-invalid':v$.Zip.$invalid && submitted}" :disabled="!editenabled" />
            </div>        
            <div class="col-6">
                <InputText type="text" maxlength="100" v-model="City" :class="{'p-invalid':v$.City.$invalid && submitted}" :disabled="!editenabled" />
            </div>                                               
        </div>        
        
        
        <div class="field grid">
            <label for="housenumber" class="col-4" :class="{'p-error': v$.HouseNumber.$invalid && submitted}">{{ translated('country') }} *</label>
            <div class="col-8">

                <Dropdown :disabled="!editenabled" v-model="selectedCountry" :options="allCountries" filter optionLabel="name" class="w-full md:w-14rem">
                    <template #value="slotProps">
                        <div v-if="slotProps.value" class="flex align-items-center">
                            <div>{{ slotProps.value.name }}</div>
                        </div>
                        <span v-else>
                            {{ slotProps.placeholder }}
                        </span>
                    </template>
                    <template #option="slotProps">
                        <div class="flex align-items-center">
                            <div>{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                </Dropdown>

            </div>                        
        </div>		


        <div class="field grid" v-if="showCompanyFields">
            <label class="col-4" :class="{'p-error': v$.TaxId.$invalid && submitted}">{{ translated('taxid') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="16" v-model="TaxId" :class="{'p-invalid':v$.TaxId.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>       
        <div class="field grid" v-if="showCompanyFields">
            <label class="col-4" :class="{'p-error': v$.RegisterId.$invalid && submitted}">{{ translated('registerid') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="10" v-model="RegisterId" :class="{'p-invalid':v$.RegisterId.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>                                                       
        <div class="field grid">
            <label class="col-4" :class="{'p-error': v$.WebSiteUrl.$invalid && submitted}">{{ translated('website') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="100" v-model="WebSiteUrl" :class="{'p-invalid':v$.WebSiteUrl.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>	      
        <div class="field grid">
            <label class="col-4" :class="{'p-error': v$.InfoEmail.$invalid && submitted}">{{ translated('companyinfoemail') }} *</label>
            <div class="col-8">
                <InputText type="text" maxlength="100" v-model="InfoEmail" :class="{'p-invalid':v$.InfoEmail.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>

        <div class="field grid">
            <label class="col-4" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('companyinfophone') }} *</label>
            <div class="col-8">
                <InputText type="text" v-model="InfoPhone" :class="{'p-invalid':v$.InfoPhone.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>     
        
        <div class="field grid" v-if="!isMinisterstvo">
            <label class="col-4" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('companyinchargeperson') }} *</label>
            <div class="col-8">
                <InputText type="text" v-model="LegalRepresentative" :class="{'p-invalid':v$.InfoPhone.$invalid && submitted}" :disabled="!editenabled" />
            </div>                        
        </div>  
        

        <div class="field grid" v-if="!isMinisterstvo">
            <div class="col-11">
                <label class="idkodepotrjene">{{ translated('idcodesapproved') }}</label>
            </div>       
            <div class="col-1">
                <Checkbox v-model="MspCpoApproved" :binary="true" disabled />
            </div>  
                       
        </div>  
        
        
        <div class="field grid checkboxHolder" v-if="showCompanyFields"> 
            <label class="col-4" :class="{'p-error': v$.CPOCode.$invalid && submitted}">{{ translated('cpotable') }}</label>
            <div class="col-1">
                <Checkbox v-model="IsOperator" :binary="true" :disabled="true" />
            </div>   
                        
            <div class="col-7" v-if="!isMinisterstvo || IsApproved==false || MspCpoApproved">

                <div class="grid" v-if="!isMinisterstvo">
                    <div class="col-3">
                        <InputText type="text" v-model="CPOCode" maxlength="10" :class="{'p-invalid':v$.CPOCode.$invalid && submitted}" :disabled="true" />                        
                    </div>        
                    <div class="col-7">
                        <Button :label="translated('requestnewid')" class="p-button-warning requestnewcodebutton" @click="openDialog('CPO')" />
                    </div>            
                    <div class="col-2">                        
                        <Button icon="pi pi-file-plus" class="scannedfile" @click="uploadSignedDoc('CPO')" :disabled="CpoCodeStatus.toLocaleLowerCase() != 'suggested'" />
                    </div>                                        
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewCpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="CpoCodeStatus.toLocaleLowerCase()">{{ NewCpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="CpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(CpoCodeStatus) }}</label>                        
                    </div>  
                    <div class="col-12">
                        <label>{{ CPOIdRejectReason }}</label>
                    </div>
                </div>

                <div class="grid" v-else>
                    <div class="col-10">
                        <InputText type="text" v-model="CPOCode" maxlength="10" :class="{'p-invalid':v$.CPOCode.$invalid && submitted}" :disabled="true" />                        
                    </div>
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('CPO')" :disabled="!hasDocument(CpoCodeStatus)" /> 
                    </div> 
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewCpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="CpoCodeStatus.toLocaleLowerCase()">{{ NewCpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="CpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(CpoCodeStatus) }}</label> 
                    </div>                                        
                </div>
                
            </div> 

            <div class="col-7" v-if="isMinisterstvo && IsApproved && !MspCpoApproved">                
                <div class="grid">
                    <div class="col-4">
                        <InputText type="text" v-model="CPOCode" maxlength="10" :class="{'p-invalid':v$.CPOCode.$invalid && submitted}" :disabled="true" />
                    </div>  

                    <div class="col-6 idcodeapprovebuttons">
                        
                        <Button :label="translated('approvebuttonlabel')" class="p-button-warning" :disabled="isReadOnly || editenabled || !IsOperator || NewCpoId.length < 4 || !isInStatusSprejet(CpoCodeStatus)" @click="approveIDCode('CPO')" />
                        <Button :label="translated('rejectbuttonlabel')" class="p-button-danger" :disabled=" isReadOnly || editenabled || !IsOperator || NewCpoId.length < 4 || !isInStatusSprejet(CpoCodeStatus)" @click="rejectIDCode('CPO')" />
                    </div>  
                        
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('CPO')" :disabled="!hasDocument(CpoCodeStatus)" /> 
                    </div> 

                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewCpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="CpoCodeStatus.toLocaleLowerCase()">{{ NewCpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="CpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(CpoCodeStatus) }}</label>
                    </div>

                </div>
            </div>             
        </div>

        
        <div class="field grid checkboxHolder" v-if="showCompanyFields">            
            <label class="col-4" :class="{'p-error': v$.MSPCode.$invalid && submitted}">{{ translated('msptable') }}</label>
            <div class="col-1">
                <Checkbox v-model="IsServiceProvider" :binary="true" :disabled="true" />
            </div>   

            <div class="col-7" v-if="!isMinisterstvo || IsApproved==false || MspCpoApproved">

                <div class="grid" v-if="!isMinisterstvo">
                    <div class="col-3">
                        <InputText type="text" v-model="MSPCode" maxlength="10" :class="{'p-invalid':v$.MSPCode.$invalid && submitted}" :disabled="true" />
                    </div>        
                    <div class="col-7">
                        <Button :label="translated('requestnewid')" class="p-button-warning requestnewcodebutton" @click="openDialog('MSP')" />
                    </div>            
                    <div class="col-2">
                        <Button icon="pi pi-file-plus" class="scannedfile" @click="uploadSignedDoc('MSP')" :disabled="MspCodeStatus.toLocaleLowerCase() != 'suggested'" />
                    </div>
 
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewMspId.length>0">{{ translated('newcodelabel') }} <b><label :class="MspCodeStatus.toLocaleLowerCase()">{{ NewMspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="MspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(MspCodeStatus) }}</label>
                    </div>   

                    
                    <div class="col-12">
                        <label>{{ MSPIdRejectReason }}</label>
                    </div>

                </div>

                <div class="grid" v-else>                    
                    <div class="col-10">
                        <InputText type="text" v-model="MSPCode" maxlength="10" :class="{'p-invalid':v$.MSPCode.$invalid && submitted}" :disabled="true" />                        
                    </div>
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('MSP')" :disabled="!hasDocument(MspCodeStatus)" /> 
                    </div> 
                    <div class="col-12">                        
                        <label class="newcodeexists" v-if="NewMspId.length>0">{{ translated('newcodelabel') }} <b><label :class="MspCodeStatus.toLocaleLowerCase()">{{ NewMspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="MspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(MspCodeStatus) }}</label>
                    </div>   
                </div>
                
            </div>   
            
            <div class="col-7" v-if="isMinisterstvo && IsApproved && !MspCpoApproved">                
                <div class="grid">
                    <div class="col-4">
                        <InputText type="text" v-model="MSPCode" maxlength="10" :class="{'p-invalid':v$.MSPCode.$invalid && submitted}" :disabled="true" />
                    </div>  

                    <div class="col-6 idcodeapprovebuttons">
                        <Button :label="translated('approvebuttonlabel')" class="p-button-warning" :disabled="isReadOnly || editenabled || !IsServiceProvider || NewMspId.length < 4 || !isInStatusSprejet(MspCodeStatus)" @click="approveIDCode('MSP')" />
                        <Button :label="translated('rejectbuttonlabel')" class="p-button-danger" :disabled=" isReadOnly || editenabled || !IsServiceProvider || NewMspId.length < 4 || !isInStatusSprejet(MspCodeStatus)" @click="rejectIDCode('MSP')" />
                    </div>      
                    
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('MSP')" :disabled="!hasDocument(MspCodeStatus)" /> 
                    </div> 

                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewMspId.length>0">{{ translated('newcodelabel') }} <b><label :class="MspCodeStatus.toLocaleLowerCase()">{{ NewMspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="MspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(MspCodeStatus) }}</label>
                    </div>
                </div>
            </div>            
        </div>      

        
        <div class="field grid checkboxHolder" v-if="showCompanyFields"> 
            <label class="col-4" :class="{'p-error': v$.RPOCode.$invalid && submitted}">{{ translated('rpotable') }}</label>
            <div class="col-1">
                <Checkbox v-model="IsRPO" :binary="true" :disabled="true" />
            </div>   

            <div class="col-7" v-if="!isMinisterstvo || IsApproved==false || MspCpoApproved">

                <div class="grid" v-if="!isMinisterstvo">
                    <div class="col-3">
                        <InputText type="text" v-model="RPOCode" maxlength="10" :class="{'p-invalid':v$.RPOCode.$invalid && submitted}" :disabled="true" />
                    </div>        
                    <div class="col-7">
                        <Button :label="translated('requestnewid')" class="p-button-warning requestnewcodebutton" @click="openDialog('RPO')" />
                    </div>            
                    <div class="col-2">
                        <Button icon="pi pi-file-plus" class="scannedfile" @click="uploadSignedDoc('RPO')" :disabled="RpoCodeStatus.toLocaleLowerCase() != 'suggested'" />
                    </div>                                        

                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewRpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="RpoCodeStatus.toLocaleLowerCase()">{{ NewRpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RpoCodeStatus) }}</label>
                    </div>  

                    
                    <div class="col-12">
                        <label>{{ RPOIdRejectReason }}</label>
                    </div>
 
                </div>

                <div class="grid" v-else>                    
                    <div class="col-10">
                        <InputText type="text" v-model="RPOCode" maxlength="10" :class="{'p-invalid':v$.RPOCode.$invalid && submitted}" :disabled="true" />                        
                    </div>
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('RPO')" :disabled="!hasDocument(RpoCodeStatus)" /> 
                    </div>                    
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewRpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="RpoCodeStatus.toLocaleLowerCase()">{{ NewRpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RpoCodeStatus) }}</label>
                    </div>   
                </div>
                
            </div>      
            
            <div class="col-7" v-if="isMinisterstvo && IsApproved && !MspCpoApproved">

                <div class="grid">
                    <div class="col-4">
                        <InputText type="text" v-model="RPOCode" maxlength="10" :class="{'p-invalid':v$.RPOCode.$invalid && submitted}" :disabled="true" />
                    </div>  

                    <div class="col-6 idcodeapprovebuttons">
                        <Button :label="translated('approvebuttonlabel')" class="p-button-warning" :disabled="isReadOnly || editenabled || !IsRPO || NewRpoId.length < 4 || !isInStatusSprejet(RpoCodeStatus)" @click="approveIDCode('RPO')" />
                        <Button :label="translated('rejectbuttonlabel')" class="p-button-danger" :disabled="isReadOnly || editenabled || !IsRPO || NewRpoId.length < 4 || !isInStatusSprejet(RpoCodeStatus)" @click="rejectIDCode('RPO')" />
                    </div>       

                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('RPO')" :disabled="!hasDocument(RpoCodeStatus)" /> 
                    </div> 
                    
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewRpoId.length>0">{{ translated('newcodelabel') }} <b><label :class="RpoCodeStatus.toLocaleLowerCase()">{{ NewRpoId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RpoCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RpoCodeStatus) }}</label>
                    </div>
                </div>
            </div>
                        
        </div>

        
        <div class="field grid nested-grid checkboxHolder" v-if="showCompanyFields">
            <label class="col-4" :class="{'p-error': v$.RSPCode.$invalid && submitted}">{{ translated('rsptable') }}</label>
            <div class="col-1">
                <Checkbox v-model="IsRSP" :binary="true" :disabled="true" />
            </div>   
            <div class="col-7" v-if="!isMinisterstvo || IsApproved==false || MspCpoApproved">
                <div class="grid" v-if="!isMinisterstvo">
                    <div class="col-3">
                        <InputText type="text" v-model="RSPCode" maxlength="10" :class="{'p-invalid':v$.RSPCode.$invalid && submitted}" :disabled="true" />
                    </div>        
                    <div class="col-7">
                        <Button :label="translated('requestnewid')" class="p-button-warning requestnewcodebutton" @click="openDialog('RSP')" />
                    </div>            
                    <div class="col-2">
                        <Button icon="pi pi-file-plus" class="scannedfile" @click="uploadSignedDoc('RSP')" :disabled="RspCodeStatus.toLocaleLowerCase() != 'suggested'" />                        
                    </div>                                        
                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewRspId.length>0">{{ translated('newcodelabel') }} <b><label :class="RspCodeStatus.toLocaleLowerCase()">{{ NewRspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RspCodeStatus) }}</label>
                    </div>  
                                        
                    <div class="col-12">
                        <label>{{ RSPIdRejectReason }}</label>
                    </div>
                </div>
                
                <div class="grid" v-else>                                        
                    <div class="col-10">
                        <InputText type="text" v-model="RSPCode" maxlength="10" :class="{'p-invalid':v$.RSPCode.$invalid && submitted}" :disabled="true" />                        
                    </div>
                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('RSP')" :disabled="!hasDocument(RspCodeStatus)" /> 
                    </div>
                    <div class="col-12">                        
                        <label class="newcodeexists" v-if="NewRspId.length>0">{{ translated('newcodelabel') }} <b><label :class="RspCodeStatus.toLocaleLowerCase()">{{ NewRspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RspCodeStatus) }}</label>
                    </div>   
                </div>

            </div>               
            
            <div class="col-7" v-if="isMinisterstvo && IsApproved && !MspCpoApproved">

                <div class="grid">
                    <div class="col-4">
                        <InputText type="text" v-model="RSPCode" maxlength="10" :class="{'p-invalid':v$.RSPCode.$invalid && submitted}" :disabled="true" />                        
                    </div>  

                    <div class="col-6 idcodeapprovebuttons">                   
                        <Button :label="translated('approvebuttonlabel')" class="p-button-warning" :disabled="isReadOnly || editenabled || !IsRSP || NewRspId.length < 4 || !isInStatusSprejet(RspCodeStatus)" @click="approveIDCode('RSP')" />
                        <Button :label="translated('rejectbuttonlabel')" class="p-button-danger" :disabled="isReadOnly || editenabled || !IsRSP || NewRspId.length < 4 || !isInStatusSprejet(RspCodeStatus)" @click="rejectIDCode('RSP')" />
                    </div>       

                    <div class="col-2">
                        <Button icon="pi pi-download" class="scannedfile" @click="downloadlastsigneddoc('RSP')" :disabled="!hasDocument(RspCodeStatus)" /> 
                    </div> 

                    <div class="col-12">
                        <label class="newcodeexists" v-if="NewRspId.length>0">{{ translated('newcodelabel') }} <b><label :class="RspCodeStatus.toLocaleLowerCase()">{{ NewRspId }}</label></b></label>
                        <label>{{ translated('statuslabel') }}</label> <label :class="RspCodeStatus.toLocaleLowerCase()">{{ getStatusLabel(RspCodeStatus) }}</label>
                    </div>
                    
                </div>
            </div>
            
        </div>            


        <div v-if="!isMinisterstvo" class="field grid legendsection">
            <label class="col-12 legendlabel" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codelegendtitle') }}</label>
            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codecpolegend') }}</label>
            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codemsplegend') }}</label>
            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('coderpolegend') }}</label>
            <label class="col-12 legendcodeitem" :class="{'p-error': v$.InfoPhone.$invalid && submitted}">{{ translated('codersplegend') }}</label>
        </div> 

        <div class="field grid" v-if="showCompanyFields">
            <div class="col-1">
                <Button v-if="editenabled" icon="pi pi-lock-open" class="p-button-rounded p-button-warning" @click="editenabled=false" />
                <Button v-if="!editenabled" icon="pi pi-lock" class="p-button-rounded p-button-warning" @click="editenabled=true" />
            </div>   
            <div class="col-11">
                <Button :label="translated('savebutton')" :disabled="!editenabled || isReadOnly" @click="saveCompany(!v$.$invalid)" />
            </div>                                   
        </div>   

        <div class="field grid" v-if="isMinisterstvo && IsApproved==false && showCompanyFields"> 
            <div class="col-12">
                <Button :label="translated('saveapprove')" class="p-button-warning" :disabled="!editenabled || isReadOnly" @click="saveCompanyAndApprove(!v$.$invalid)" />
            </div>                                   
        </div>      

        <!-- <div class="field grid" v-if="isMinisterstvo && IsApproved & !MspCpoApproved && showCompanyFields"> 
            <div class="col-12">
                <Button :label="translated('saveapprovecode')" class="p-button-warning" :disabled="!editenabled" @click="saveCompanyAndApproveCode(!v$.$invalid)" />
            </div>                                   
        </div>  -->

    </div>

        <!-- PrimeVue Dialog component as a modal popup -->
    <Dialog :header="translated('newcodetitle')" v-model:visible="showDialog" modal closable @hide="handleHide">
    <!-- <Dialog header="Enter New Code" :visible="showDialog" modal closable @hide="onCancel"> -->
        <div class="p-fluid">
            <div class="p-field">
                <label for="newCode">{{ translated('newcode') }}</label>
                <InputText id="newCode" v-model="newCode" />
            </div>
        </div>
        <template #footer>
            <Button :label="translated('newcodecancel')" icon="pi pi-times" class="p-button-text" @click="onCancel" />
            <Button :label="translated('newcodeok')" icon="pi pi-check" @click="onOk" />
        </template>
    </Dialog>
            
    <Dialog :header="translated('rejectpopuptitle')" v-model:visible="showRejectedDialog" modal closable @hide="handleRejectedHide" :style="{width: '500px'}">
        <div class="p-fluid">
            <div class="p-field">
                <label for="newCode">{{ translated('rejectpopuplabel') }}</label>
                <Textarea id="newCode" v-model="rejectedReasonText" :style="{height: '100px'}" />
            </div>
        </div>
        <template #footer>
            <Button :label="translated('newcodecancel')" icon="pi pi-times" class="p-button-text" @click="onCancelRejected" />
            <Button :label="translated('rejectbuttonlabel')" class="p-button-danger" @click="onReject" />
        </template>
    </Dialog>

</template>

<script>
import { email, required, between, numeric, minLength, maxLength, requiredUnless, requiredIf, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

import Dialog from 'primevue/dialog';
import Spinner from "@/components/Spinner.vue"
import createHttp from "@/services/http";
import { computed } from "vue"
import store from "@/store";

import countries from '@/components/countries.js'

//const davcna = (value) => (value.match(/^[A-Z]{2}[0-9]{8,12}$/) == value);
const mspcpoid = (value) => (value.match(/^[A-Z]{2}[\*|-][A-Z0-9]{3}$/) == value);

function davcna(input) {
    const pattern = /^[A-Z]{2}[A-Z0-9]{6,15}$/;
    return pattern.test(input);
}


export default {
    components: { Spinner, Dialog },
    props: ['isLocked','companyid'],
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            isSubmitting: false,
            submitted: false,
            Id:'',
            CompanyName: '',
            Street: '',
            Street1: '',
            HouseNumber: '',
            Zip: '',
            City: '',
            TaxId: '',
            RegisterId: '',
            WebSiteUrl: '',
            InfoEmail: '',
            InfoPhone: '',
            LegalRepresentative: '',
            IsOperator: false,
            IsServiceProvider: false,
            IsRPO: false,
            IsRSP: false,
            Email: '',
            NameSurname: '',
            MSPCode: '',
            CPOCode:'',
            RSPCode:'',
            RPOCode:'',
            NewCpoId: '',
            NewMspId: '',
            NewRspId: '',
            NewRpoId: '',
            IsApproved: false,
            MspCpoApproved: false,
            Errors: [],  
            editenabled: true,
            translated: computed(() => store.getters.getTranslate),
            selectedCountry: null, 
            allCountries: null,
            CpoCodeStatus: '',
            MspCodeStatus: '',
            RspCodeStatus: '',
            RpoCodeStatus: '',

            lastPopupCode: '',
            showDialog: false,
            showRejectedDialog: false,
            newCode: '',
            CPOIdRejectReason: '',
            MSPIdRejectReason: '',
            RPOIdRejectReason: '',
            RSPIdRejectReason: '',
        }
    },
    validations() {
        let regexp = /^\d\d:\d\d$/;
        

        let myvalidations = {
            CompanyName: { required },
            Street: { required },
            HouseNumber: { required },
            Zip: { required, between: between(1000, 999999) },
            City: { required },
            TaxId: { required, davcna },
            RegisterId: { numeric, minLength: minLength(7), maxLength: maxLength(10), required },
            WebSiteUrl: { required },
            InfoEmail: { required, email },
            InfoPhone: { required },
            LegalRepresentative: { required },
            MSPCode: { }, 
            CPOCode: { },           
            RPOCode: { },           
            RSPCode: { }           
        };

        // if(this.isMSP) { myvalidations.MSPCode = { required, mspcpoid }; }
        // if(this.isCPO) { myvalidations.CPOCode = { required, mspcpoid }; }        

        // if(this.isRSP) { myvalidations.RSPCode = { required, mspcpoid }; }        
        // if(this.isRPO) { myvalidations.RPOCode = { required, mspcpoid }; }        

        return myvalidations;
    },
    computed: {
        isMSP() {            
            return this.IsServiceProvider;
        },
        isCPO() {
            return this.IsOperator;
        },        
        isRPO() {
            return this.IsRPO;
        },
        isRSP() {
            return this.IsRSP;
        },
        isMinisterstvo() {
            return (this.$store.getters.isInRole("MAdmin") || this.$store.getters.isInRole("MUser"));
            //return (this.$store.getters.getRole=="MAdmin" || this.$store.getters.getRole=="MUser");
        },
        isReadOnly() {
            return this.$store.getters.isInRole("ReadOnly");
        },
        showCompanyFields() {
            let undefinedCompany = this.companyid==undefined;
            if(!undefinedCompany)
                undefinedCompany = this.companyid == '';
                    

            return !this.isMinisterstvo || (this.isMinisterstvo && !undefinedCompany);
            //return !this.isMinisterstvo || (this.isMinisterstvo && this.companyid!=undefined);
        }
    },   
    /*
    beforeRouteUpdate(to, from, next) {
        
        console.log('BEFORE ENTER');
        console.log(to);
        console.log(from);
        //console.log('approved:' + to.params.approved);
        
       // this.LoadData(to.params.approved);

        next();
    },      */
    async mounted() {
        //console.log('translate saveapprovecode');
        // this.translated('saveapprovecode')

        this.allCountries = countries;        
        this.loadCompany();
    },  
    methods: {
        async loadCompany() {       
            let undefinedCompany = this.companyid == undefined;

            if(!undefinedCompany)
                undefinedCompany = this.companyid == '';

            //console.log('undefined company: ' + undefinedCompany);

            this.editenabled = false;

            let DashBoardUrl = process.env.VUE_APP_API_FOLDER + "/GetCompany";

            if(this.companyid){
                if(this.companyid!='00000000-0000-0000-0000-000000000000') {
                    DashBoardUrl = DashBoardUrl + '?loadCompanyId=' + this.companyid
                }                
            }                    

            console.log("URL: " + DashBoardUrl);
            const http = createHttp(true);
            const resultGC = await http.get(DashBoardUrl);
            console.log(resultGC);
            if (resultGC.status == 200) {
                this.CompanyName = resultGC.data.Name;
                this.Street = resultGC.data.Street;
                this.Street1 = resultGC.data.Street1;
                this.HouseNumber = resultGC.data.Housenumber;
                this.Zip = resultGC.data.Zip;
                this.City = resultGC.data.City;
                this.TaxId = resultGC.data.TaxId;
                this.WebSiteUrl = resultGC.data.WebSiteUrl;
                this.InfoEmail = resultGC.data.Email;
                this.InfoPhone = resultGC.data.Phone;
                this.IsOperator = resultGC.data.IsOperator;
                this.IsServiceProvider = resultGC.data.IsServiceprovider;
                this.MSPCode = resultGC.data.MspId;
                this.CPOCode = resultGC.data.CpoId;
                this.RegisterId = resultGC.data.RegisterId;
                this.Id = resultGC.data.Id;
                this.IsApproved = resultGC.data.IsApproved;
                this.MspCpoApproved = resultGC.data.MspCpoApproved;
                //console.log(this.energysite)
                this.selectedCountry = this.allCountries.find(country => country.code == resultGC.data.CountryCode);

                this.IsRPO = resultGC.data.IsRpo;
                this.IsRSP = resultGC.data.IsRsp;
                this.RPOCode = resultGC.data.RpoId;
                this.RSPCode = resultGC.data.RspId;
                this.LegalRepresentative = resultGC.data.LegalRepresentative;

                this.CpoCodeStatus = resultGC.data.CpoCodeStatus;
                this.MspCodeStatus = resultGC.data.MspCodeStatus;
                this.RpoCodeStatus = resultGC.data.RpoCodeStatus;
                this.RspCodeStatus = resultGC.data.RspCodeStatus;

                this.NewCpoId = resultGC.data.NewCpoId ?? '';
                this.NewMspId = resultGC.data.NewMspId ?? '';
                this.NewRpoId = resultGC.data.NewRpoId ?? '';
                this.NewRspId = resultGC.data.NewRspId ?? '';
                
                this.CPOIdRejectReason = resultGC.data.CPOIdRejectReason ?? '';
                this.MSPIdRejectReason = resultGC.data.MSPIdRejectReason ?? '';
                this.RPOIdRejectReason = resultGC.data.RPOIdRejectReason ?? '';
                this.RSPIdRejectReason = resultGC.data.RSPIdRejectReason ?? '';
                
            }      
        },
        async requestNewIDCode(code, codeid) {
            this.isSubmitting = true;
            
            const http = createHttp(true); 
            try {
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/RequestNewIDCode", {
                    companyId: this.Id,
                    codeName: code,
                    codeid: codeid
                });

                // console.log('response na RequestNewIDCode')
                // console.log(response)

                if(response.status==200) {
                    // console.log('VSE JE OK!!!');   
                    this.loadCompany();
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Status changed!', life: 3000});                 
                } else {
                    // console.log('ERROR!!!')
                    this.$toast.add({severity:'error', summary:'Error', detail:'Status not changed', life: 3000});
                }

                console.log(response)
            } catch (error) {
                // console.log(error);
                this.$toast.add({severity:'error', summary:'Error', detail:'Status not changed', life: 3000});
            }  
            this.isSubmitting = false;
        },
        approveIDCode(code) {
            this.setCodeStatus(code, 'approved');
        },
        rejectIDCode(code) {
            // Odprejm dialog za rejected reason
            this.openRejectedDialog(code);
            // this.setCodeStatus(code, 'rejected');
        },
        async setCodeStatus(code, status, rejectedreason = '') {
            this.isSubmitting = true;
            
            const http = createHttp(true); 
            try {
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/ChangeCompanyCodeStatus", {
                    companyId: this.Id,
                    codeName: code,
                    codeStatus: status,
                    rejectedReason : rejectedreason
                });

                // console.log('response na ChangeCompanyCodeStatus')
                // console.log(response)

                if(response.status==200) {
                    // console.log('VSE JE OK!!!');   
                    this.loadCompany();        
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Status changed!', life: 3000});          
                } else {
                    // console.log('ERROR!!!')
                    this.$toast.add({severity:'error', summary:'Error', detail:'Status not changed', life: 3000});
                }

                console.log(response)
            } catch (error) {
                this.$toast.add({severity:'error', summary:'Error', detail:'Status not changed', life: 3000});
                // console.log(error);
            }  
            this.isSubmitting = false;
        },
        isInStatusSprejet(statusname) {
            // console.log('Gorazd', statusname);
            // return statusname.toLowerCase() == 'suggested';
            return statusname.toLowerCase() == 'accepted';
        },
        getStatusLabel(statusname) {
            switch (statusname.toLowerCase()) {
                case "undefined": return this.translated('codestatusUndefined');
                case "suggested": return this.translated('codestatusSuggested');
                case "accepted": return this.translated('codestatusAccepted');
                case "approved": return this.translated('codestatusApproved');
                case "rejected": return this.translated('codestatusRejected');
                default: return this.translated('codestatusUndefined');                    
            }
        },
        
        hasDocument(statusname) {
            return statusname.toLowerCase() == 'approved' || statusname.toLowerCase() == 'rejected' || statusname.toLowerCase() == 'accepted';
        },

        getCompanyObj() {
            return {
                Name: this.CompanyName,
                Street: this.Street,
                Street1: this.Street1,
                Housenumber: this.HouseNumber,
                Zip: this.Zip,
                City: this.City,
                TaxId: this.TaxId,
                WebSiteUrl: this.WebSiteUrl,
                Email: this.InfoEmail,
                Phone: this.InfoPhone,
                IsOperator: this.IsOperator,
                IsServiceprovider: this.IsServiceProvider,
                MspId: this.MSPCode,
                CpoId: this.CPOCode,
                RegisterId: this.RegisterId,
                Id: this.Id,
                IsApproved: this.IsApproved,
                MspCpoApproved: this.MspCpoApproved,
                CountryCode: this.selectedCountry.code,

                IsRPO: this.IsRPO,
                IsRSP: this.IsRSP,
                RpoId: this.RPOCode,
                RspId: this.RSPCode,
                LegalRepresentative: this.LegalRepresentative
            };
        },

        async saveCompanyAndApprove(isFormValid) {

            this.submitted = true;
            if (!isFormValid) {
                return;
            }

            this.isSubmitting = true;
            //console.log('shranjujem podatke APPROVE');

            const objToSave = this.getCompanyObj();

            //console.log(objToSave);

            const http = createHttp(true); 
            try {
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/ApproveCompany?languageCode=SI", objToSave);
                //console.log('response na ApproveCompany')
                //console.log(response)

                if(response.status==200) {
                    //console.log('VSE JE OK!!!');
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Data saved!', life: 3000});
                    setTimeout(() => this.$router.push({ name: 'Companies', params: { approved: 0 } }), 1500);
                    
                    
                } else {
                    // console.log('ERROR!!!')
                    this.$toast.add({severity:'error', summary:'Error', detail:'Data not saved', life: 3000});
                }

                // console.log(response)
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(error);
                this.$toast.add({severity:'error', summary:'Error', detail:'Data not saved', life: 3000});
            }  
            this.isSubmitting = false;
        },
        async saveCompanyAndApproveCode(isFormValid) {

            this.submitted = true;
            if (!isFormValid) {
                return;
            }

            this.isSubmitting = true;
            //console.log('shranjujem podatke APPROVE CODE');

            const objToSave = this.getCompanyObj();

            //console.log(objToSave);

            const http = createHttp(true); 
            try {
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/ApproveCompanyCode?languageCode=SI", objToSave);
                /*
                console.log('response na ApproveCompanyCode')
                console.log(response)
                */

                if(response.status==200) {
                    //console.log('VSE JE OK!!!');
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Data saved!', life: 3000});
                    setTimeout(() => this.$router.push({ name: 'Companies', params: { approved: 3 } }), 1500);
                    
                } else {
                    console.log('ERROR!!!')
                    this.$toast.add({severity:'error', summary:'Error', detail:'Data not saved', life: 3000});
                }

                //console.log(response)
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                // console.log(error);
                this.$toast.add({severity:'error', summary:'Error', detail:'Data not saved', life: 3000});
            }  
            this.isSubmitting = false;
        },        
        async saveCompany(isFormValid) {

            this.submitted = true;
            if (!isFormValid) {
                return;
            }

            this.isSubmitting = true;
            //console.log('shranjujem podatke');

            const objToSave = this.getCompanyObj();

            //console.log(objToSave);
            debugger;

            const http = createHttp(true); 
            try {
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/UpdateCompany?languageCode=SI", objToSave);
                /*
                console.log('response na Update BusinessCompany')
                console.log(response)
                */

                if(response.status==200) {
                    //console.log('VSE JE OK!!!');
                    this.$toast.add({severity:'success', summary:'Confirmed', detail:'Data saved!', life: 3000});
                    //setTimeout(() => this.$router.push({ name: 'Companies', params: { approved: 0 } }), 1500);
                    
                    
                } else {
                    console.log('POST ERROR!!!')
                }

                //console.log(response)
            } catch (error) {
                //console.log('ERROR TRY CATCHE!');
                console.log(error);
            }   
            this.isSubmitting = false;         
        },
        onFileSelected(event) {
            // Get the selected file (if any)
            const files = event.target.files;
            if (files && files[0]) {
                const selectedFile = files[0];

                // Optional: Reset the file input value so that the same file
                // can be selected consecutively if needed.
                event.target.value = null;

                // Call the uploading function (you can pass any needed parameters)
                this.uploadFile(selectedFile, this.currentCode);
            }
        },
        async uploadFile(file, code) {
            // Create a FormData object to hold the code and file

            this.isSubmitting = true;
            const formData = new FormData();
            formData.append("code", code);
            formData.append("file", file);

            try {
                const http = createHttp(true); 
                const response = await http.post(process.env.VUE_APP_API_FOLDER + "/SaveDocument", formData, {
                    headers: { "Content-Type": "multipart/form-data" },
                });

                await this.loadCompany();
                // Handle successful response
                // console.log("Upload success:", response.data);
            } catch (error) {
                // Handle error appropriately
                console.error("Error uploading file:", error);
            }

            this.isSubmitting = false;
        },        
        uploadSignedDoc(code){
            this.currentCode = code;            
            this.$refs.fileInput.click();
        },
        openDialog(code) {
            this.lastPopupCode = code;
            this.showDialog = true;
        },
        openRejectedDialog(code) {
            this.lastPopupCode = code;
            this.showRejectedDialog = true;            
        },
        async onOk() {
            // Replace the following line with your server call.
            //console.log("New Code:", this.newCode, this.lastPopupCode);

            await this.requestNewIDCode(this.lastPopupCode, this.newCode);

            this.newCode = '';
            this.showDialog = false;
            this.lastPopupCode = '';
        },
        async onReject() {                        
            await this.setCodeStatus(this.lastPopupCode, 'rejected', this.rejectedReasonText);
            this.showRejectedDialog = false;
        },
        onCancel() {
            console.log('Cancel', this.lastPopupCode);
            this.newCode = '';
            this.showDialog = false;
            this.lastPopupCode = '';
        },
        onCancelRejected() {
            console.log('Cancel Rejected');
            this.rejectedReasonText = '';
            this.showRejectedDialog = false;
            this.lastPopupCode = '';
        },
        handleHide() {
            if (this.okPressed) {
                this.okPressed = false;
            } else {
                this.newCode = '';
            }
        },
        handleRejectedHide() {
            if (this.okPressed) {
                this.okPressed = false;
            } else {
                this.rejectedReasonText = '';
            }
        },
        async downloadlastsigneddoc(code) {
            const http = createHttp(true); 
            const url = process.env.VUE_APP_API_FOLDER + `/GetLastFile?code=${code}&cid=${this.Id}`;
            try {
                // Fetch the PDF file as a blob
                const response = await http.get(url, { responseType: "blob" });
                const fileBlob = new Blob([response.data], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(fileBlob);
                
                // Open the blob URL in a new tab/window
                window.open(fileURL, "_blank");
            } catch (error) {
                console.error("Error opening PDF file:", error);
                // Optionally, display an error message to the user.
            }
        }
    }   
}
</script>

<style scoped>
.checkboxHolder .p-checkbox.p-component {margin-top: 7px;}
.card.fluid.companydatacard {min-height: 470px;}
input.p-inputtext {width: 100%;}
.p-dropdown {width: 100% !important;}

.idcodeapprovebuttons {display: flex;justify-content: space-around;}
.checkboxHolder {margin-top: 40px !important;}

button.requestnewcodebutton {width:100%}
label.idkodepotrjene {font-weight:bold;}

label.newcodeexists {margin-right: 10px;}
label.idkodesection {font-weight: bold;margin-top: 30px;}
label.legendlabel {font-weight: bold;margin-top: 20px;margin-bottom: 10px;}
.legendsection {margin-bottom: 50px;}
label.rejected {color: #d23e02;}
</style>